export const noHoverOnTouchDevice = "@media (hover: hover) and (pointer: fine)";

export const defaultUnderlineStyle = {
    textDecoration: "underline",
    textDecorationThickness: "1px",
    textUnderlineOffset: "4px",
};

/**
 * Shared link styles for rich text content (Hero, LegalText, PageHeading, etc.).
 * Use with: "& a, & button[data-type='modal-link']": richTextLinkStyle
 */
export const richTextLinkStyle = {
    color: "inherit",
    fontWeight: "bold",
    ...defaultUnderlineStyle,
    "&:hover": {
        color: "gray.500",
        textDecorationColor: "gray.500",
    },
};

export const animatedUnderline = {
    ...defaultUnderlineStyle,
    textDecorationColor: "black",
    transition: "text-decoration-color 300ms",
};
